import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Typewriter } from "typewriting-react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import {
  getVGMData,
  uploadVGMDocAggregate,
  uploadVGMDocFiveM,
  uploadVGMDocTractor,
} from "../../services/VGMService";
import { toast } from "react-toastify";
import { viewDoc } from "../../services/dataService";
import LoaderSpinner from "./LoaderSpinner";
import { VGMPDFLogoImg, VGMPDFLogoStamp} from "../../utils/VGMImages";

function VGMPDFViewer({ date, show, hide }) {
  const [loading, setLoading] = useState(false);
  const [docLink, setDocLink] = useState("");

  useEffect(() => {
    async function getData() {

      const doc = new jsPDF();

      doc.addImage(VGMPDFLogoImg, "PNG", 15, 5, 70, 40).setFontSize(10);
      doc.text(140, 10, "John Deere India Private Limited").setFontSize(10);
      doc.text(140, 15, "CIN - U74220PN1997PTC112441").setFontSize(10);
      doc.text(140, 20, "Unit: John Deere Pune Works").setFontSize(10);
      doc.text(140, 25, "Off Pune Nagar Road, Sanaswadi").setFontSize(10);
      doc.text(140, 30, "Pune 412208, India").setFontSize(10);
      doc.text(140, 35, "Tel: +91 (2137) 667111").setFontSize(10);
      doc.text(140, 40, "Tel: +91 (2137) 666837 / 666838").setFontSize(10);

      doc.addImage(VGMPDFLogoStamp, "PNG", 150, 190, 35, 35);

      autoTable(doc, {
        headerStyles: {
          lineWidth: 0.2,
          lineColor: "rgb(249, 249, 249)",
        },
        head: [
          [{ content: "Annex - 1", colSpan: 2, styles: { halign: "center" } }],
          [
            {
              content: "INFORMATION ABOUT VERIFIED GROSS MASS OF CONTAINER",
              colSpan: 2,
              styles: { halign: "center" },
            },
          ],
          [
            { content: "Details of Information", styles: { halign: "center" } },
            { content: "Particulars", styles: { halign: "center" } },
          ],
        ],
        body: [
          ["Name of the Shipper", show.row.original.shippername],
          [
            "Shipper Registration / License No. (IEC No./CIN No.) **",
            show.row.original.Shipper_Lic_No,
          ],
          [
            "Name and designation of official of the shipper authorized to sign document",
            show.row.original.Shipper_Authorised_Name,
          ],
          [
            "24 x 7 contact details of authorized official of shipper",
            show.row.original.Mobile_Number,
          ],
          ["Container No.", show.row.original.Container_Number],
          ["Container size (TUE/FEU/Other)", show.row.original.Container_Type],
          [
            "Maximum permissible weight of container as per the CSC plate",
            show.row.original.Container_Weight,
          ],
          [
            "Weighbridge registration no. & Address of Weighbridge",
            `${
              show.row.original.Weibridge_Reg_No
                ? show.row.original.Weibridge_Reg_No
                : ""
            }, ${
              show.row.original.Weibridge_Address
                ? show.row.original.Weibridge_Address
                : ""
            }`,
          ],
          [
            "Verified gross mass of container (method- 1/method-2)",
            show.row.original.Container_Mass,
          ],
          [
            "Date and time of weighting",
            show.row.original.Weighing_Date
              ? moment(show.row.original.Weighing_Date).format(
                  "DD-MM-YYYY HH:mm"
                )
              : "",
          ],
          ["Weighting slip no.", show.row.original.Weighing_Slip_No],
          ["Type(Normal/Reefer/Hazardous/Others)", show.row.original.VGM_Type],
          ["If Hazardous, UN No., IMDG class", show.row.original.Remarks],
        ],
        margin: { top: 43 },
      });
      doc.setFontSize(11);
      doc.text(110, 230, "Signature of authorized person of shipper");
      doc.text(110, 235, `Name - ${show.row.original.Shipper_Authorised_Name}`);
      doc.text(110, 240, `Date - ${moment().format("DD/MM/YYYY")}`);
      doc.setFontSize(11);
      doc.text(15, 245, "Remarks:- ").setFont(undefined, "normal");
      doc
        .text(35, 245, "* Indicates mandatory fields")
        .setFont(undefined, "normal");
      doc
        .text(
          35,
          250,
          "** Shipper not having IEC No. or CIN No. may provide information as follows:"
        )
        .setFont(undefined, "normal");
      doc.text(35, 255, "Company - PAN No.").setFont(undefined, "normal");
      doc.text(35, 260, "Individuals").setFont(undefined, "normal");
      doc
        .text(35, 265, "Indian National - AADHAR No.")
        .setFont(undefined, "normal");
      doc
        .text(
          35,
          270,
          "Foreign National - PASSPORT No. & Country of issue of passport."
        )
        .setFontSize(13)
        .setFont(undefined, "normal");

      doc
        .text(
          10,
          280,
          "Registered Office:- Tower 14, Cybercity,Magarpatta City, Hadapsar,Pune - 411013. India"
        )
        .setFontSize(12)
        .setFont(undefined, "normal");
      doc
        .text(55, 285, "Tel No: +91(20)66425000, Fax: +91(20)66425001")
        .setFontSize(12)
        .setFont(undefined, "normal");
      doc
        .text(75, 290, "Website: www.deere.co.in")
        .setFontSize(12)
        .setFont(undefined, "normal");
      var pdf = doc.output("datauristring").split(",");
      const PDFFile = {
        base64String: `${pdf[1]}`,
        fileName: `${show.row.original.Container_Number}.pdf`,
        vgmId: show.row.original.VGMId,
      };
      if (show.row.original.DataOf === "TRACTOR") {
        try {
          var filteredResponse = {};
          setLoading(true);
          await uploadVGMDocTractor(PDFFile);
          const response = await getVGMData(date);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].VGMId === show.row.original.VGMId) {
              filteredResponse = response.data[i];
            }
          }
          const VGMDocResponse = await viewDoc(filteredResponse.VGMDoc);
          setDocLink(VGMDocResponse.data.Message);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          toast.error("Something went wrong...please try again");
        }
      }
      if (show.row.original.DataOf === "AGGREGATE") {
        try {
          var filteredResponseAgg = {};
          setLoading(true);
          await uploadVGMDocAggregate(PDFFile);
          const response = await getVGMData(date);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].VGMId === show.row.original.VGMId) {
              filteredResponseAgg = response.data[i];
            }
          }
          const VGMDocResponse = await viewDoc(filteredResponseAgg.VGMDoc);
          setDocLink(VGMDocResponse.data.Message);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          toast.error("Something went wrong...please try again");
        }
      }
      if (show.row.original.DataOf === "5M") {
        try {
          var filteredResponse5M = {};
          setLoading(true);
          await uploadVGMDocFiveM(PDFFile);
          const response = await getVGMData(date);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].VGMId === show.row.original.VGMId) {
              filteredResponse5M = response.data[i];
            }
          }
          const VGMDocResponse = await viewDoc(filteredResponse5M.VGMDoc);
          setDocLink(VGMDocResponse.data.Message);
          setLoading(false);
        } catch (error) {
          setLoading(false);
          toast.error("Something went wrong...please try again");
        }
      }
    }
    getData();
  }, [date, show]);

  // async function downloadClickHandler() {

  // }
  return (
    <>
      <Modal
        show={show}
        backdrop="static"
        centered
        dialogClassName="VGMPDFViewerModalWidth"
        contentClassName="VGMPDFViewerModalHeight"
      >
        <Modal.Body>
          <div>
            <span
              style={{ fontSize: "20px", fontWeight: "500" }}
            >{`#${show.row.original.Container_Number}`}</span>
            <Button className="fr mr-2 btn-sm" onClick={() => hide()}>
              Close
            </Button>
            {/* {!show.row.original.VGMDoc && (
              <Button
                className="fr btn-sm"
                style={{ marginRight: "25px" }}
                onClick={downloadClickHandler}
                disabled={!show.row.original.VGMId || loading === "Generating"}
              >
                {loading}
              </Button>
            )}
            {show.row.original.VGMDoc && (
              <Button
                className="fr btn-sm"
                style={{ marginRight: "25px" }}
                onClick={downloadClickHandler}
                disabled={loadingUpdateBtn === "Updating"}
              >
                {loadingUpdateBtn}
              </Button>
            )} */}
            <div className="VGMPDFViewerIframe">
              {docLink === null && show.row.original.VGMDoc && (
                <Typewriter
                  words={["Generate The PDF To View..."]}
                  cursorClassName="cursor"
                  className="VGMPDFTypewritter"
                />
              )}
              {loading && (
                <>
                  <div
                    style={{
                      display: "flex",
                      marginLeft: "40%",
                      marginTop: "25%",
                    }}
                  >
                    <p style={{ fontSize: "25px" }}>Generating PDF...</p>
                    <LoaderSpinner />
                  </div>
                </>
              )}
              {docLink !== "" && <iframe title="VGMDoc" src={docLink} />}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default VGMPDFViewer;
